<template>
    <Link :href="'/'">
        <img src="/logo.jpg" alt="logo" style="max-width: 450px;">
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            Link,
        },
    }
</script>
